'use strict';

angular.module('tdl.controllers').controller('LegalController', ['$scope', 
  function LegalController($scope) {



  }
]);